document.addEventListener('DOMContentLoaded', function () {
  var phoneInput = document.getElementById('phone');
  var form = document.getElementById('customerClubForm');
  var responseBox = document.getElementById('responseBox');
  var invoiceNumberInput = document.getElementById('invoiceNumber');
  var refNumberCheckbox = document.getElementById('refNumber');
  var refNumberLabel = refNumberCheckbox ? refNumberCheckbox.closest('label') : null;
  // Инициализация кнопок и выпадающих списков
  const watchesButton = document.getElementById('watches-button');
  const diamondsButton = document.getElementById('diamonds-button');
  const dropdownsContainer = document.querySelector('.dropdowns-container');
  const firstProductBlock = document.querySelector('.product-type-block .product-type-block:first-child');

  const watchesOptions = {
    subtitle: 'מותג:',
    options: [
      { value: 'FCUK', label: 'FCUK' },
      { value: 'Versace', label: 'Versace' },
      { value: 'Doxa', label: 'Doxa' },
      { value: 'אחר', label: 'אחר' }
    ]
  };

  const diamondsOptions = {
    subtitle: '?איזה סוג של יהלומים נרכשו',
    options: [
      { value: 'יהלומים טבעיים', label: 'יהלומים טבעיים' },
      { value: 'יהלומי מעבדה', label: 'יהלומי מעבדה' }
    ]
  };

  function createDropdown(id, options, placeholder) {
    const dropdown = document.createElement('div');
    dropdown.className = 'dropdown-options';
    dropdown.id = id + '-dropdown';

    const subtitle = document.createElement('div');
    subtitle.className = 'dropdown-subtitle';
    subtitle.textContent = options.subtitle;
    dropdown.appendChild(subtitle);

    const radioGroup = document.createElement('div');
    radioGroup.className = 'dropdown-radio-group';

    options.options.forEach(option => {
      const label = document.createElement('label');
      const radio = document.createElement('input');
      radio.type = 'radio';
      radio.name = id;
      radio.value = option.value;
      radio.id = id + '-' + option.value;
      label.appendChild(radio);
      label.appendChild(document.createTextNode(option.label));
      radioGroup.appendChild(label);

      radio.addEventListener('change', function () {
        if (this.checked) {
          document.getElementById(id).value = this.value;
        }
      });
    });

    dropdown.appendChild(radioGroup);
    return dropdown;
  }

  function toggleDropdown(buttonId, dropdownId) {
    const dropdown = document.getElementById(dropdownId);
    const button = document.getElementById(buttonId);
    if (!dropdown || !button) return;

    const isOpen = dropdown.classList.contains('open');

    // Переключаем текущий dropdown
    if (isOpen) {
      dropdown.classList.remove('open');
      button.classList.remove('active');
    } else {
      dropdown.classList.add('open');
      button.classList.add('active');
    }
  }

  // Создаем и добавляем выпадающие списки
  if (dropdownsContainer && firstProductBlock) {
    const watchesDropdown = createDropdown('watches', watchesOptions, 'שעון');
    const diamondsDropdown = createDropdown('diamonds', diamondsOptions, 'תכשיט יהלום');

    dropdownsContainer.appendChild(watchesDropdown);
    dropdownsContainer.appendChild(diamondsDropdown);

    // Обработчики кликов на кнопки
    if (watchesButton) {
      watchesButton.addEventListener('click', function () {
        toggleDropdown('watches-button', 'watches-dropdown');
      });
    }

    if (diamondsButton) {
      diamondsButton.addEventListener('click', function () {
        toggleDropdown('diamonds-button', 'diamonds-dropdown');
      });
    }

  }

  // Логика взаимного блокирования invoiceNumber и refNumber
  if (invoiceNumberInput && refNumberCheckbox) {
    // Если чекбокс refNumber отмечен, блокируем invoiceNumber
    refNumberCheckbox.addEventListener('change', function () {
      if (this.checked) {
        invoiceNumberInput.disabled = true;
        invoiceNumberInput.value = '';
        invoiceNumberInput.style.borderColor = '#bbb';
      } else {
        invoiceNumberInput.disabled = false;
        invoiceNumberInput.style.borderColor = '#888';
      }
    });

    // Если в invoiceNumber появляется значение, блокируем чекбокс refNumber
    invoiceNumberInput.addEventListener('input', function () {
      this.value = this.value.replace(/[^0-9]/g, '');
      if (this.value.trim() !== '') {
        refNumberCheckbox.disabled = true;
        refNumberCheckbox.checked = false;
        refNumberLabel.style.opacity = '0.5';
        refNumberLabel.style.pointerEvents = 'none';
      } else {
        refNumberCheckbox.disabled = false;
        refNumberLabel.style.opacity = '';
        refNumberLabel.style.pointerEvents = '';
      }
    });
  }

  if (phoneInput) {
    phoneInput.addEventListener('input', function (e) {
      this.value = this.value.replace(/[^0-9]/g, '');

      // Если поле пустое, сбрасываем форму и очищаем responseBox
      if (this.value.trim() === '') {
        if (form) {
          form.reset();
          // После reset нужно восстановить логику блокирования
          if (invoiceNumberInput && refNumberCheckbox) {
            invoiceNumberInput.disabled = false;
            refNumberCheckbox.disabled = false;
            // Восстанавливаем стили лейбла
            if (refNumberLabel) {
              refNumberLabel.style.opacity = '';
              refNumberLabel.style.pointerEvents = '';
            }
          }
          // Сбрасываем кнопки и выпадающие списки
          const watchesHidden = document.getElementById('watches');
          const diamondsHidden = document.getElementById('diamonds');
          if (watchesHidden) watchesHidden.value = '';
          if (diamondsHidden) diamondsHidden.value = '';

          // Убираем активное состояние с кнопок
          if (watchesButton) {
            watchesButton.classList.remove('active');
          }
          if (diamondsButton) {
            diamondsButton.classList.remove('active');
          }

          // Сбрасываем радиобаттоны
          document.querySelectorAll('.dropdown-radio-group input[type="radio"]').forEach(radio => {
            radio.checked = false;
          });

          // Закрываем все выпадающие списки
          document.querySelectorAll('.dropdown-options.open').forEach(dropdown => {
            dropdown.classList.remove('open');
          });
        }
        if (responseBox) {
          responseBox.innerHTML = '';
          responseBox.style.display = 'none';
        }
      }
    });
  }
});

document
  .getElementById("customerClubForm")
  .addEventListener("submit", async function (e) {
    e.preventDefault();

    const invoiceNumber = document.getElementById("invoiceNumber").value.trim();
    let phone = document.getElementById("phone").value.trim();
    const checkboxes = document.querySelectorAll('input[name="itemBought"]:checked');
    const itemBought = Array.from(checkboxes).map((cb) => cb.value);
    const refNumberCheckbox = document.getElementById("refNumber");

    // Получаем значения из hidden inputs
    const watchesInput = document.getElementById("watches");
    const diamondsInput = document.getElementById("diamonds");
    const watchesValue = watchesInput ? watchesInput.value : '';
    const diamondsValue = diamondsInput ? diamondsInput.value : '';

    // Добавляем значения select в itemBought, если они выбраны
    if (watchesValue) {
      itemBought.push('מותג שעוני יד: ' + watchesValue);
    }
    if (diamondsValue) {
      itemBought.push(diamondsValue);
    }

    const responseBox = document.getElementById("responseBox");

    // Валидация: либо invoiceNumber заполнено, либо чекбокс refNumber отмечен
    const hasInvoiceOrRef = invoiceNumber || (refNumberCheckbox && refNumberCheckbox.checked);
    if (!hasInvoiceOrRef || !phone || itemBought.length === 0) {
      alert("נא למלא את כל השדות");
      return;
    }

    // Обработка номера телефона: оставляем только последние 9 цифр и добавляем 0 в начало
    const phoneDigits = phone.replace(/[^0-9]/g, '');
    if (phoneDigits.length < 9) {
      alert("נא להזין מספר טלפון תקין");
      return;
    }

    // Берем последние 9 цифр и добавляем 0 в начало
    const last9Digits = phoneDigits.slice(-9);
    phone = '0' + last9Digits;
    
    // add checkbox param
    const customerOrderedBefore = refNumberCheckbox ? refNumberCheckbox.checked : false;

    // Формируем query-параметры для автозаполнения
    const params = new URLSearchParams({
      phone: phone,
      invoiceNumber: invoiceNumber,
      itemBought: itemBought.join(",")
    });

    const payload = {
      phone: phone,
      invoiceNumber: invoiceNumber,
      itemBought: itemBought
    };

    try {
      const res = await fetch("http://vip.pozylov.co.il/apps/inforu-check", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        throw new Error(errorData.error || `HTTP ${res.status}`);
      }

      const data = await res.json();

      if (data.exists) {
        // Ссылка для автозаполнения существующего клиента
        const link = `/customer-club/existing-customer?${params.toString()}`;
        responseBox.innerHTML = `
          <h2>לקוח קיים</h2>
          <p class="response-button">${data.contactId}</p>
          <p class="response-button">${data.name}</p>
          <button class="response-button" id="existingCustomerBtn">סיים</button>
        `;
        document.getElementById("existingCustomerBtn").onclick = async function () {
          try {
            //await sendSms('existing', phone, data.name, link); 
            await sendSms(
              'existing',
              phone,
              data.name,
              link,
              customerOrderedBefore
            );
          } catch (error) {
            console.error("Error sending SMS:", error);
            alert("שגיאה בשליחת SMS");
          }
        };
      } else {
        // Ссылка для автозаполнения нового клиента
        const link = `/customer-club/new-customer?${params.toString()}`;
        responseBox.innerHTML = `
          <h2>לקוח חדש</h2>
          <button class="response-button" id="newCustomerBtn">סיים</button>
        `;
        document.getElementById("newCustomerBtn").onclick = async function () {
          try {
            //await sendSms('new', phone, '', link);
            await sendSms(
              'new',
              phone,
              '',
              link,
              customerOrderedBefore
            );
          } catch (error) {
            console.error("Error sending SMS:", error);
            alert("שגיאה בשליחת SMS");
          }
        };
      }

      responseBox.style.display = "block";
    } catch (error) {
      console.error("Error checking client:", error);
      alert("שגיאה בבדיקת לקוח - נא לנסות שוב");
    }
  });

  async function sendSms(
    type,
    phone,
    name = "",
    link = "",
    customerOrderedBefore = false
    ) {
    try {
      const payload = {
        type,
        phone,
        name,
        link,
        customerOrderedBefore
      };

      const res = await fetch("http://vip.pozylov.co.il/apps/inforu-sms", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        throw new Error(errorData.error || `HTTP ${res.status}`);
      }

      alert("הודעת SMS נשלחה");
    } catch (error) {
      console.error("Error sending SMS:", error);
      throw error;
    }
  }




// DROPDOWNS VERSION
// document.addEventListener('DOMContentLoaded', function () {
//   var phoneInput = document.getElementById('phone');
//   var form = document.getElementById('customerClubForm');
//   var responseBox = document.getElementById('responseBox');
//   var invoiceNumberInput = document.getElementById('invoiceNumber');
//   var refNumberCheckbox = document.getElementById('refNumber');
//   var refNumberLabel = refNumberCheckbox ? refNumberCheckbox.closest('label') : null;
//   var watchesSelect = document.getElementById('watches');
//   var watchesPlaceholder = document.getElementById('watches-placeholder');
//   var diamondsSelect = document.getElementById('diamonds');
//   var diamondsPlaceholder = document.getElementById('diamonds-placeholder');

//   // Функция для обновления отображения select watches
//   function updateWatchesDisplay() {
//     if (watchesSelect && watchesPlaceholder) {
//       if (watchesSelect.value === '') {
//         // Если ничего не выбрано, показываем placeholder
//         watchesPlaceholder.style.display = 'block';
//         watchesSelect.style.color = 'transparent';
//       } else {
//         // Если выбрано значение, скрываем placeholder
//         watchesPlaceholder.style.display = 'none';
//         watchesSelect.style.setProperty('color', '#333', 'important');
//       }
//     }
//   }

//   // Функция для обновления отображения select diamonds
//   function updateDiamondsDisplay() {
//     if (diamondsSelect && diamondsPlaceholder) {
//       if (diamondsSelect.value === '') {
//         // Если ничего не выбрано, показываем placeholder
//         diamondsPlaceholder.style.display = 'block';
//         diamondsSelect.style.color = 'transparent';
//       } else {
//         // Если выбрано значение, скрываем placeholder
//         diamondsPlaceholder.style.display = 'none';
//         diamondsSelect.style.setProperty('color', '#333', 'important');
//       }
//     }
//   }

//   // Инициализация отображения watches select
//   if (watchesSelect) {
//     updateWatchesDisplay();
//     watchesSelect.addEventListener('change', updateWatchesDisplay);
//     // Обновляем при потере фокуса
//     watchesSelect.addEventListener('blur', updateWatchesDisplay);
//   }

//   // Инициализация отображения diamonds select
//   if (diamondsSelect) {
//     updateDiamondsDisplay();
//     diamondsSelect.addEventListener('change', updateDiamondsDisplay);
//     // Обновляем при потере фокуса
//     diamondsSelect.addEventListener('blur', updateDiamondsDisplay);
//   }

//   // Логика взаимного блокирования invoiceNumber и refNumber
//   if (invoiceNumberInput && refNumberCheckbox) {
//     // Если чекбокс refNumber отмечен, блокируем invoiceNumber
//     refNumberCheckbox.addEventListener('change', function () {
//       if (this.checked) {
//         invoiceNumberInput.disabled = true;
//         invoiceNumberInput.value = '';
//         invoiceNumberInput.style.borderColor = '#bbb';
//       } else {
//         invoiceNumberInput.disabled = false;
//         invoiceNumberInput.style.borderColor = '#888';
//       }
//     });

//     // Если в invoiceNumber появляется значение, блокируем чекбокс refNumber
//     invoiceNumberInput.addEventListener('input', function () {
//       this.value = this.value.replace(/[^0-9]/g, '');
//       if (this.value.trim() !== '') {
//         refNumberCheckbox.disabled = true;
//         refNumberCheckbox.checked = false;
//         refNumberLabel.style.opacity = '0.5';
//         refNumberLabel.style.pointerEvents = 'none';
//       } else {
//         refNumberCheckbox.disabled = false;
//         refNumberLabel.style.opacity = '';
//         refNumberLabel.style.pointerEvents = '';
//       }
//     });
//   }

//   if (phoneInput) {
//     phoneInput.addEventListener('input', function (e) {
//       this.value = this.value.replace(/[^0-9]/g, '');

//       // Если поле пустое, сбрасываем форму и очищаем responseBox
//       if (this.value.trim() === '') {
//         if (form) {
//           form.reset();
//           // После reset нужно восстановить логику блокирования
//           if (invoiceNumberInput && refNumberCheckbox) {
//             invoiceNumberInput.disabled = false;
//             refNumberCheckbox.disabled = false;
//             // Восстанавливаем стили лейбла
//             if (refNumberLabel) {
//               refNumberLabel.style.opacity = '';
//               refNumberLabel.style.pointerEvents = '';
//             }
//           }
//           // Сбрасываем select элементы к значениям по умолчанию
//           if (watchesSelect) {
//             watchesSelect.selectedIndex = 0;
//             updateWatchesDisplay();
//           }
//           if (diamondsSelect) {
//             diamondsSelect.selectedIndex = 0;
//             updateDiamondsDisplay();
//           }
//         }
//         if (responseBox) {
//           responseBox.innerHTML = '';
//           responseBox.style.display = 'none';
//         }
//       }
//     });
//   }
// });

// document
//   .getElementById("customerClubForm")
//   .addEventListener("submit", async function (e) {
//     e.preventDefault();

//     const invoiceNumber = document.getElementById("invoiceNumber").value.trim();
//     let phone = document.getElementById("phone").value.trim();
//     const checkboxes = document.querySelectorAll('input[name="itemBought"]:checked');
//     const itemBought = Array.from(checkboxes).map((cb) => cb.value);
//     const refNumberCheckbox = document.getElementById("refNumber");

//     // Получаем значения из select элементов
//     const watchesSelect = document.getElementById("watches");
//     const diamondsSelect = document.getElementById("diamonds");
//     const watchesValue = watchesSelect ? watchesSelect.value : '';
//     const diamondsValue = diamondsSelect ? diamondsSelect.value : '';

//     // Добавляем значения select в itemBought, если они выбраны
//     if (watchesValue) {
//       itemBought.push('מותג שעוני יד: ' + watchesValue);
//     }
//     if (diamondsValue) {
//       itemBought.push(diamondsValue);
//     }

//     const responseBox = document.getElementById("responseBox");

//     // Валидация: либо invoiceNumber заполнено, либо чекбокс refNumber отмечен
//     const hasInvoiceOrRef = invoiceNumber || (refNumberCheckbox && refNumberCheckbox.checked);
//     if (!hasInvoiceOrRef || !phone || itemBought.length === 0) {
//       alert("נא למלא את כל השדות");
//       return;
//     }

//     // Обработка номера телефона: оставляем только последние 9 цифр и добавляем 0 в начало
//     const phoneDigits = phone.replace(/[^0-9]/g, '');
//     if (phoneDigits.length < 9) {
//       alert("נא להזין מספר טלפון תקין");
//       return;
//     }

//     // Берем последние 9 цифр и добавляем 0 в начало
//     const last9Digits = phoneDigits.slice(-9);
//     phone = '0' + last9Digits;

//     // Формируем query-параметры для автозаполнения
//     const params = new URLSearchParams({
//       phone: phone,
//       invoiceNumber: invoiceNumber,
//       itemBought: itemBought.join(",")
//     });

//     const payload = {
//       phone: phone,
//       invoiceNumber: invoiceNumber,
//       itemBought: itemBought
//     };

//     try {
//       const res = await fetch("http://vip.pozylov.co.il/apps/inforu-check", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });

//       if (!res.ok) {
//         const errorData = await res.json().catch(() => ({}));
//         throw new Error(errorData.error || `HTTP ${res.status}`);
//       }

//       const data = await res.json();

//       if (data.exists) {
//         // Ссылка для автозаполнения существующего клиента
//         const link = `/customer-club/existing-customer?${params.toString()}`;
//         responseBox.innerHTML = `
//           <h2>לקוח קיים</h2>
//           <p class="response-button">${data.contactId}</p>
//           <p class="response-button">${data.name}</p>
//           <button class="response-button" id="existingCustomerBtn">סיים</button>
//         `;
//         document.getElementById("existingCustomerBtn").onclick = async function () {
//           try {
//             await sendSms('existing', phone, data.name, link);
//           } catch (error) {
//             console.error("Error sending SMS:", error);
//             alert("שגיאה בשליחת SMS");
//           }
//         };
//       } else {
//         // Ссылка для автозаполнения нового клиента
//         const link = `/customer-club/new-customer?${params.toString()}`;
//         responseBox.innerHTML = `
//           <h2>לקוח חדש</h2>
//           <button class="response-button" id="newCustomerBtn">סיים</button>
//         `;
//         document.getElementById("newCustomerBtn").onclick = async function () {
//           try {
//             await sendSms('new', phone, '', link);
//           } catch (error) {
//             console.error("Error sending SMS:", error);
//             alert("שגיאה בשליחת SMS");
//           }
//         };
//       }

//       responseBox.style.display = "block";
//     } catch (error) {
//       console.error("Error checking client:", error);
//       alert("שגיאה בבדיקת לקוח - נא לנסות שוב");
//     }
//   });

// async function sendSms(type, phone, name = "", link = "") {
//   try {
//     const res = await fetch("http://vip.pozylov.co.il/apps/inforu-sms", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ type, phone, name, link }),
//     });

//     if (!res.ok) {
//       const errorData = await res.json().catch(() => ({}));
//       throw new Error(errorData.error || `HTTP ${res.status}`);
//     }

//     alert("הודעת SMS נשלחה");
//   } catch (error) {
//     console.error("Error sending SMS:", error);
//     throw error;
//   }
// }
